import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import {
  loadHomeworkDetail,
  clearHomeworkDetail,
  savePublicHomework,
} from '../../common/homeworks/actions'
import { loadResultsByHomework } from '../../common/results/actions'
import { Title, BackLink, PageHeader, GuideMessage, ResultsList, Button } from '../components'

class HomeworkDetailPage extends React.Component {
  componentDidMount() {
    const { loadHomeworkDetail, loadResultsByHomework, match } = this.props
    loadHomeworkDetail(match.params.id)
    loadResultsByHomework(match.params.id)
  }

  componentWillUnmount() {
    this.props.clearHomeworkDetail()
  }

  render() {
    const { currentHomework, results, intl } = this.props

    if (!currentHomework) return null

    return (
      <div>
        <Title message={`Homework ${currentHomework.name}`} />
        <BackLink />
        <PageHeader
          title={`${intl.formatMessage(messages.homework)} ${currentHomework.name}`}
        />
        <GuideMessage
          text={`${intl.formatMessage(messages.homeworkUrl)}: vobo.io/homework/${currentHomework.homeworkId}`}
        />
        <div className="full-width">
          <h3 className="float-left">{intl.formatMessage(messages.exercises)}:</h3>
          <div className="homework-lessons-list">
            {
              currentHomework.lessons.map(l => (
                <div className="item-box" key={l.id}>
                  <Link to={`/lessons/${l.id}`}>
                    <h4>{l.name}</h4>
                  </Link>
                </div>
              ))
            }
          </div>
        </div>
        <div className="full-width">
          <h3 className="float-left">{intl.formatMessage(messages.results)}:</h3>
          <ResultsList results={results} homework={currentHomework} />
        </div>
        <div className="float-left spacing-top">
          <Link className="float-left spacing-right" to={`/app/edit-homework/${currentHomework.id}`}>
            <Button className="disable-spacing-left">{intl.formatMessage(messages.edit)}</Button>
          </Link>
        </div>
      </div>
    )
  }
}

HomeworkDetailPage.defaultProps = {
  currentHomework: null,
  results: [],
  viewer: null,
  match: null,
}

HomeworkDetailPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadHomeworkDetail: PropTypes.func.isRequired,
  clearHomeworkDetail: PropTypes.func.isRequired,
  savePublicHomework: PropTypes.func.isRequired,
  loadResultsByHomework: PropTypes.func.isRequired,
  results: PropTypes.array,
  currentHomework: PropTypes.object,
  viewer: PropTypes.object,
  match: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    currentHomework: state.homeworks.currentHomework,
    results: state.results.all,
    viewer: state.users.viewer,
  }), { clearHomeworkDetail, loadHomeworkDetail, savePublicHomework, loadResultsByHomework }),
  injectIntl,
)

export default enhance(HomeworkDetailPage)

const messages = defineMessages({
  homework: {
    id: 'homework.page.homework',
    defaultMessage: 'Domáca úloha',
  },
  homeworkUrl: {
    id: 'homework.page.homeworkUrl',
    defaultMessage: 'Adresa domácej úlohy',
  },
  exercises: {
    id: 'homework.page.exercises',
    defaultMessage: 'Cvičenia',
  },
  results: {
    id: 'homework.page.results',
    defaultMessage: 'Výsledky',
  },
  edit: {
    id: 'homework.page.edit',
    defaultMessage: 'Upraviť',
  },
  save: {
    id: 'homework.page.save',
    defaultMessage: 'Uložiť',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/HomeworkDetailPage.js